import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import BaseComponent from '../../../general/js/base-component';
import stylesFinally from '../../../general/js/style-observer'

export default class LotGalleryComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.carouselElement = this.refs.carousel;
        this.navElement = this.refs.nav;
        this.currentElement = this.refs.current;
        this.totalElement = this.refs.total;

        stylesFinally(() => {
            this.init();
        })
    }

    static getRequiredRefs() {
        return ['carousel', 'nav', 'current', 'total'];
    }

    init() {
        this.$carouselElement = $(this.carouselElement);

        this.$carouselElement.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            appendArrows: this.navElement,
            prevArrow: `<button type="button" class="lot-gallery__arrow lot-gallery__arrow--prev">
                            <svg width="7" height="13" class="icon">
                                <use xlink:href="#icon-arrow-left"></use>
                            </svg>
                        </button>`,
            nextArrow: `<button type="button" class="lot-gallery__arrow lot-gallery__arrow--next">
                            <svg width="7" height="13" class="icon">
                                <use xlink:href="#icon-arrow-right"></use>
                            </svg>
                        </button>`,
        });

        let slick = this.$carouselElement.slick('getSlick');
        this.totalElement.textContent = slick.slideCount;
        this.$carouselElement.on('afterChange', (e, instance, currentSlideIndex) => {
            this.currentElement.textContent = currentSlideIndex + 1;
        });
    }

    onDestroy() {
        this.$carouselElement.slick('unslick');
    }
}



// WEBPACK FOOTER //
// ./app/components/lot-details/js/lot-gallery.component.js